import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileDvr"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 11.25V8.25C22.5 7.42157 21.8284 6.75 21 6.75H16.5V17.25H18V12.75H19.11L20.865 17.25H22.5L20.7525 12.75H21C21.8284 12.75 22.5 12.0784 22.5 11.25ZM18 8.25H21V11.25H18V8.25ZM13.5 6.75L12 16.5L10.5 6.75H9L10.89 17.25H13.11L15 6.75H13.5ZM4.5 17.25H1.5V6.75H4.5C6.15685 6.75 7.5 8.09315 7.5 9.75V14.25C7.5 15.9069 6.15685 17.25 4.5 17.25ZM3 15.75H4.5C5.32843 15.75 6 15.0784 6 14.25V9.75C6 8.92157 5.32843 8.25 4.5 8.25H3V15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileDvr.vue"]]);
